export default {
    items: [
        // {
        //     name: 'Бухгалтерия',    //НСБ › Агентство › Бухгалтерия
        //     url: '/agency/control',
        //     icon: 'icon-puzzle'
        // },
        // {
        //     name: 'Контроль продаж',    //НСБ › Агентство › Контроль продаж
        //     url: '/agency/control',
        //     icon: 'icon-puzzle'
        // },
        // {
        //     name: 'Аналитика',          //НСБ › Агентство › Аналитика
        //     url: '/agency/control',
        //     icon: 'icon-puzzle'
        // },
        // {
        //     name: 'Звонки агентов',
        //     url: '/agency/calls',
        //     icon: 'icon-puzzle'
        // },
        {
            name: 'Экспорт данных',
            url: '/agency/dataexport',
            icon: 'icon-cloud-download',
        },
        {
            name: 'Импорт данных',
            url: '/agency/dataimport',
            icon: 'icon-cloud-upload',
        },
        {
            name: 'Путевки',
            url: '/agency/vouchers',
            icon: 'icon-briefcase'
        },
        {
            name: 'Заявки',
            url: '/agency/orders',
            icon: 'icon-bag'
        },
        {
            name: 'Заезды',
            url: '/agency/checkins',
            icon: 'fa fa-taxi'
        },
        {
            name: 'Вознаграждение',
            url: '/agency/fees',
            icon: 'fa fa-money',
        },
        {
            name: 'Агентство',
            url: '/agency/profile',
            icon: 'fa fa-users',
            badge: {
                variant: 'danger',
                text: 'NEW'
            }
        },
        {
            name: 'Счет в системе',
            url: '/agency/account',
            icon: 'fa fa-money',
            badge: {
                variant: 'danger',
                text: 'NEW'
            }
        },
        {
            name: 'Финансы',
            url: '/agency/finances',
            icon: 'fa fa-money',
            badge: {
                variant: 'danger',
                text: 'NEW'
            }
        },
        {
            name: 'Платежи',
            url: '/agency/payments',
            icon: 'fa fa-money',
            badge: {
                variant: 'danger',
                text: 'NEW'
            }
        },

        {
            name: 'Отчеты',
            url: '/agency/reports',
            icon: 'icon-book-open',
            badge: {
                variant: 'danger',
                text: 'NEW'
            }
        },
    ]
}
